function rawApiBaseFromEnv(): string {
  const fromBase = import.meta.env.VITE_API_BASE_URL?.trim() ?? ''
  if (fromBase.length > 0) return fromBase
  const fromSigchatx = import.meta.env.VITE_SIGCHATX_BASE_URL?.trim() ?? ''
  return fromSigchatx
}

function stripTrailingSlash(s: string): string {
  return s.endsWith('/') ? s.slice(0, -1) : s
}

function normaliseAbsoluteHost(raw: string): string {
  return stripTrailingSlash(raw.replace(/\/sigchat\/v1\/?$/i, ''))
}

function sameOriginAuthPath(token: string, apiBase: string): string {
  const prefix =
    apiBase.length > 0 && apiBase.startsWith('/')
      ? stripTrailingSlash(apiBase)
      : '/sigchat/v1'
  return `${prefix}/contact/${encodeURIComponent(token)}/auth`
}

export function contactAuthUrl(token: string): string {
  if (import.meta.env.DEV) {
    return sameOriginAuthPath(token, '/sigchat/v1')
  }
  const raw = rawApiBaseFromEnv()
  if (raw.length === 0 || raw.startsWith('/')) {
    return sameOriginAuthPath(token, raw)
  }
  const host = normaliseAbsoluteHost(raw)
  return `${host}/sigchat/v1/contact/${encodeURIComponent(token)}/auth`
}
